import produce from "immer";
import { EmailsAction } from ".";
import { IStoreState } from "../initialStoreState";
import { initialEmailsState } from "./Emails.types";
import {
  CLEAR_EMAILS_STATE,
  FETCH_EMAIL_HISTORY_LOG_LIST_FAILED,
  FETCH_EMAIL_HISTORY_LOG_LIST_PROGRESS,
  FETCH_EMAIL_HISTORY_LOG_LIST_SUCCESS,
} from "./EmailsAction";
import { LoadState } from "../../constants/enums";

export const emailsReducer = (
  state: IStoreState["emails"] = initialEmailsState,
  action: EmailsAction
) => {
  switch (action.type) {
    case FETCH_EMAIL_HISTORY_LOG_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.emailsHistoryLog.loading = LoadState.InProgress;
        draftState.emailsHistoryLog.list = [];
        draftState.emailsHistoryLog.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_EMAIL_HISTORY_LOG_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.emailsHistoryLog.loading = LoadState.Loaded;
        draftState.emailsHistoryLog.list = list;
        draftState.emailsHistoryLog.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_EMAIL_HISTORY_LOG_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.emailsHistoryLog.loading = LoadState.InProgress;
        draftState.emailsHistoryLog.list = [];
        draftState.emailsHistoryLog.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_EMAILS_STATE: {
      return initialEmailsState;
    }
    default: {
      return state;
    }
  }
};
